document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const drawer = document.querySelector('.drawer-nav');
  const overlay = document.querySelector('.drawer-overlay');
  const openIcon = '\u00D7'; // ×
  const closedIcon = '\u2630'; // ☰

  function openDrawer() {
    drawer.classList.add('open');
    overlay.classList.add('visible');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.textContent = openIcon;
    toggle.setAttribute('aria-label', 'Close navigation');
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('visible');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.textContent = closedIcon;
    toggle.setAttribute('aria-label', 'Open navigation');
  }

  toggle.addEventListener('click', () => {
    if (drawer.classList.contains('open')) closeDrawer();
    else openDrawer();
  });

  overlay.addEventListener('click', closeDrawer);

  // Close drawer when any link inside it is clicked
  drawer.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeDrawer);
  });
});
